import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../common.service';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
export class HelpComponent implements OnInit {


	faq_data = [
	{
		'question' : 'When does my coverage begin?',
		'answer': [{
			'answer_title' : 'Your insurance coverage begins the moment the policy number has been issued.',
			'answer_details':['Before a policy number is issued, you must sign the policy document which should indicate your preferred date.','If you do not request a deferred date, then the assumption would be to make it effective immediately.','You can request a deferred date; you cannot retract the date when the policy takes effect. This ensures you are clear of the policy start date, if you have questions it is best to contact your insurance agent.']
		}]
		
	},
	{
		'question' : 'What if I haven\'t received my policy card yet?',
		'answer': [{
			'answer_title' : 'It takes 7 – 10 business days to receive your commercial policy card in the mail.',
			'answer_details':['You should have received an emailed copy of the policy coverage details once the policy number was issued.','If you have a policy number to reference, you will have coverage in place.','If you have not received policy details, contact your insurance agent immediately.']
		}]
	},
	{
		'question' : 'When is my next payment due?',
		'answer': [{
			'answer_title' : 'When obtaining an insurance policy, you will have determined what your preferred payment schedule is (e.g., monthly, quarterly, annually).',
			'answer_details':['Premiums are paid as a lump sum or in installments during the duration of the policy. ','A failure to pay the premium when due automatically cancels the insurance policy which, upon payment of the outstanding amount within a certain period, may be restored.']
		}]
			
	},
	{
		'question' : 'How do I file a claim?',
		'answer': [
		{
			'answer_title' : '',
			'answer_details':["Click the CLAIMS button above or call 800 555 1234."]
		},
		{
			'answer_title' : 'When a fire, accident or theft occurs at your business:',
			'answer_details':['You should have received an emailed copy of the policy coverage details once the policy number was issued.','If you have a policy number to reference, you will have coverage in place.','If you have not received policy details, contact your insurance agent immediately.']
		},
		{
			'answer_title' : 'After a disaster:',
			'answer_details':['Take steps to protect your property from further damage by making temporary repairs.','If immediate repairs to equipment are necessary, save the damaged parts in case the claims adjuster is interested in examining them.','Get at least two bids on the cost to repair or replace damaged property.']
		},
		{
			'answer_title' : 'When filing a business interruption claim:',
			'answer_details':['Be able to show the income the business was generating both before and after the loss. ','Keep detailed records of business activity and the extra expenses of keeping your business operating in a temporary location during the interruption period.','If you are forced to close, include expenses that continue during the time that the business is closed, such as advertising and the cost of utilities.']
		},
		
		]
		
	}]
	panelOpenState = false;
	constructor(private commonService: CommonService) { }

	ngOnInit() {
		this.commonService.changeHeaderLeftIcon("../../../assets/icons/menu.svg")
        this.commonService.changeHeader('faq')
	}

}
